import { Box, styled, Typography } from '@mui/material';

interface PageNotFoundWrapperStyledProps {
  $isFullScreen: boolean;
}

export const PageNotFoundWrapperStyled = styled(
  Box
)<PageNotFoundWrapperStyledProps>(({ theme, $isFullScreen }) => ({
  color: theme.palette.primary?.main,
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(6),
  textAlign: 'center',
  ...($isFullScreen
    ? {
        height: '100vh',
        '@supports (height: 100dvh)': {
          height: '100dvh',
        },
      }
    : {}),
}));

export const PageNotFound404Styled = styled(Typography)({
  lineHeight: 1,
});

export const PageNotFoundDescriptionStyled = styled(Typography)(
  ({ theme }) => ({
    color: theme.palette.primaryDark.main,
  })
);
